import React from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const PriceFormItem = () => {
  return (
    <Item
      name="price"
      label="Prix"
      rules={[
        {
          required: true,
          message: "Merci d'entrer un prix."
        }
      ]}
    >
      <Input type="number"/>
    </Item>
  );

};

export default PriceFormItem;